// extracted by extract-css-chunks-webpack-plugin
module.exports = {"table":"summary-table__table___3qf1_","row":"summary-table__row___3H5ku","fund-name":"summary-table__fund-name___CIBka","fundName":"summary-table__fund-name___CIBka","amount":"summary-table__amount___3TcG3","total":"summary-table__total___3Wz99","total-amount":"summary-table__total-amount___DcLv6","totalAmount":"summary-table__total-amount___DcLv6"};
    if(module.hot) {
      // 1747869510748
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  